import { createClient } from '@supabase/supabase-js';
import { getGuestWriteToken } from '../lib/guestRoomToken';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim();
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim();

if (!supabaseUrl || !supabaseAnonKey) {
  const missingVars = [
    !supabaseUrl ? 'VITE_SUPABASE_URL' : null,
    !supabaseAnonKey ? 'VITE_SUPABASE_ANON_KEY' : null,
  ].filter(Boolean);

  throw new Error(
    `Missing Supabase env vars: ${missingVars.join(', ')}. ` +
      'Set them in frontend/.env (and hosting build env) before starting the app.'
  );
}

/**
 * RLS гостя проверяет `x-timer-guest-token` (см. timer_can_manage_room). Добавляем
 * заголовок к POST/GET/PATCH к PostgREST, если в URL/теле виден room id.
 */
function extractRoomIdForGuestHeader(input: RequestInfo | URL, init?: RequestInit): string | null {
  const u =
    typeof input === 'string'
      ? input
      : input instanceof URL
        ? input.href
        : input instanceof Request
          ? input.url
          : String(input);
  const roomEq = u.match(/room_id=eq\.([^&]+)/);
  if (roomEq?.[1]) {
    return decodeURIComponent(roomEq[1]!.replace(/\+/g, ' '));
  }
  if (u.includes('timer_rooms') && u.includes('id=eq.')) {
    const idEq = u.match(/id=eq\.([^&]+)/);
    if (idEq?.[1]) return decodeURIComponent(idEq[1]!.replace(/\+/g, ' '));
  }
  if (init?.body && typeof init.body === 'string') {
    try {
      const j = JSON.parse(init.body) as
        | { p_room_id?: string; room_id?: string }
        | Array<{ p_room_id?: string; room_id?: string }>;
      if (Array.isArray(j)) {
        for (const row of j) {
          if (row?.p_room_id && String(row.p_room_id).length > 0) return String(row.p_room_id);
          if (row?.room_id && String(row.room_id).length > 0) return String(row.room_id);
        }
      } else {
        if (j.p_room_id && String(j.p_room_id).length > 0) return String(j.p_room_id);
        if (j.room_id && String(j.room_id).length > 0) return String(j.room_id);
      }
    } catch {
      // ignore
    }
  }
  return null;
}

const supabaseGlobalFetch: typeof fetch = (input, init) => {
  const roomId = extractRoomIdForGuestHeader(input, init);
  const token = roomId ? getGuestWriteToken(roomId) : null;
  if (!token) {
    return fetch(input, init);
  }
  const h = new Headers(
    (init as RequestInit | undefined)?.headers as HeadersInit | undefined,
  );
  if (!h.has('x-timer-guest-token')) {
    h.set('x-timer-guest-token', token);
  }
  return fetch(input, { ...init, headers: h });
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  global: { fetch: supabaseGlobalFetch },
});
